<tilby-dialog-toolbar 
    title="{{data.printerName}}"
    (confirm)="confirm()"
/>
<tilby-dialog-content>
    <div #contentPreview class="tw-border-gray-200 tw-border-solid"></div>
</tilby-dialog-content>